import { createContext } from "react";
import { DependentsContextProps } from "../../types/contexts/dependentContext2/dependentContextProps.types";

const DependentsContext = createContext({} as DependentsContextProps);

export default DependentsContext;
